export default __webpack_public_path__ + "static/media/preloader-bg.e2b2ee1e.jpg";